import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import { Box } from '../../primitives/Box/Box.es.js';
import Popover from '../Popover/Popover.es.js';
import '../Popover/PopoverContext.es.js';
import { List } from '../List/List.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, themeMode, fontWeight, color, fontSize, radius, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
var Separator = styled(Box).attrs(function () {
  return {
    as: "li",
    role: "presentation",
    "aria-hidden": true
  };
}).withConfig({
  componentId: "sc-12ujx3k-0"
})(["display:inline-flex;align-items:center;pointer-events:none;margin:0 ", ";color:", ";"], spacing("xs"), themeMode({
  dark: color("neutral.400"),
  light: color("neutral.500")
}));
var Placeholder = styled(Box).attrs(function () {
  return {
    as: "button"
  };
}).withConfig({
  componentId: "sc-12ujx3k-1"
})(["display:inline-flex;align-items:center;font-weight:", ";outline:none;color:", ";padding:0;cursor:pointer;&:hover{color:inherit;text-decoration:underline;}"], fontWeight("bold"), themeMode({
  dark: color("neutral.400"),
  light: color("neutral.500")
}));
var PopoverContent = styled(Popover.Content).withConfig({
  componentId: "sc-12ujx3k-2"
})(["padding:0;"]);
var PopoverList = styled(List).withConfig({
  componentId: "sc-12ujx3k-3"
})(["padding:", " 0;", ";"], spacing("xs"), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint("md", "up")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        max-width: 375px;\n        max-height: 160px;\n    "])));
});
var sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "sm",
      lineHeight: "16px",
      minHeight: "24px",
      py: "xs",
      px: "sm"
    },
    md: {
      fontSize: "md",
      lineHeight: "18px",
      minHeight: "48px",
      py: "xs",
      px: "md"
    }
  }
});
var ListItem = styled(List.Item).withConfig({
  componentId: "sc-12ujx3k-4"
})(["max-width:100%;text-decoration:none;user-select:none;cursor:pointer;display:flex;align-items:center;font-weight:", ";word-break:break-all;", ";&:hover{color:", ";background-color:", ";}&:active{color:", ";background-color:", ";}& > a{color:", ";},"], fontWeight("bold"), sizeStyles, color("text.base"), themeMode({
  light: color("neutral.100"),
  dark: color("neutral.700")
}), color("text.base"), themeMode({
  light: color("neutral.200"),
  dark: color("neutral.600")
}), themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
}));
var Item = styled(Box).attrs(function () {
  return {
    as: "li"
  };
}).withConfig({
  componentId: "sc-12ujx3k-5"
})(["display:inline-flex;align-items:center;font-size:", ";color:", ";&:hover,&:last-child{color:", ";}&:not(:first-child){overflow:hidden;}"], function (_ref2) {
  var size = _ref2.size;
  return size && fontSize(size);
}, themeMode({
  dark: color("neutral.400"),
  light: color("neutral.500")
}), themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
}));
var Link = styled("a").attrs(function (_ref3) {
  var isCurrent = _ref3.isCurrent;
  return {
    "aria-current": isCurrent ? "page" : void 0,
    role: "link"
  };
}).withConfig({
  componentId: "sc-12ujx3k-6"
})(["flex:0 1 auto;position:relative;text-decoration:none;color:inherit;font-size:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:hover{color:inherit;cursor:pointer;text-decoration:underline;}&[aria-current='page']{cursor:default;font-weight:", ";color:", ";text-decoration:none;pointer-events:none;}&:not(:first-child){margin-left:", ";}&:focus-visible{outline:0;box-shadow:none;}&:after{content:'';position:absolute;top:-3px;left:-6px;width:calc(100% + 12px);height:calc(100% + 6px);opacity:0;transition:opacity 200ms ease-in;border-width:2px;border-style:solid;border-color:", ";border-radius:", ";}&:focus-visible:after{opacity:1;}"], function (_ref4) {
  var size = _ref4.size;
  return size && fontSize(size);
}, fontWeight("bold"), themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
}), spacing("xs"), color("border.base"), radius("lg"));
var Wrapper = styled(Box).attrs(function () {
  return {
    as: "ol"
  };
}).withConfig({
  componentId: "sc-12ujx3k-7"
})(["display:flex;margin:0;"]);
var Breadcrumb = styled(Box).attrs(function () {
  return {
    as: "nav"
  };
}).withConfig({
  componentId: "sc-12ujx3k-8"
})(["width:100%;"]);
export { Breadcrumb, Item, Link, ListItem, Placeholder, PopoverContent, PopoverList, Separator, Wrapper };